export default {
      id: "icon-wifi-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-wifi",
      toString: function () {
        return this.url;
      }
    }